module.exports = __webpack_public_path__ + "static/media/2007-dan.dbdf5286.jpg";